import { useBlockState } from './block-section.hook';
import { BlockMenu, BlockConfirmationModal } from './components';

const BlockSection = () => {
	const {
		isBlocked,
		isBlockModalOpen,
		isBlockLoading,
		handleConfirmBlock,
		handleBlockMenuClick,
		handleBlockModalOpenChange,
		handleCancelBlock,
		trackChatMenuOpen,
	} = useBlockState();

	return (
		<>
			<BlockMenu
				isBlocked={isBlocked}
				onBlockMenuClick={handleBlockMenuClick}
				onMenuOpen={trackChatMenuOpen}
			/>
			<BlockConfirmationModal
				isOpen={isBlockModalOpen}
				isBlocked={isBlocked}
				isLoading={isBlockLoading}
				onOpenChange={handleBlockModalOpenChange}
				onConfirm={handleConfirmBlock}
				onCancel={handleCancelBlock}
			/>
		</>
	);
};

BlockSection.displayName = 'BlockSection';
export { BlockSection };
